import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoImg from 'eco-design/base/eco-img';
import EFXQuiet from '@elem/ui-assets/icons/unregular/EFXQuiet';
import { useMediaDevice } from '@elem/compPage/Oasis/hooks';
import EfSection from '@elem/ui/ef-section';

const JJ: React.FC = () => {
    const { t } = useLang('delta3series');
    const { isH5 } = useMediaDevice();
    return (
        <div className={styles.comp} id="d3-J">
            <EcoSpace />
            {/* <EcoSectionCommon label={t('J_label')} title={t('J_title')} desc={t('J_desc')} /> */}
            <EfSection label={t('J_label')} title={t('J_title')} desc={t('J_desc')} />
            <EcoSpaceSmall />
            {!isH5 && (
                <div className="box">
                    <div className="img-box-left">
                        <EcoImg pc={'https://websiteoss.ecoflow.com/upload/image/1741159445124/%E5%8D%A7%E5%AE%A4_X-QUIET_%E6%89%A9%E5%9B%BE%20(1).jpg'} />
                    </div>
                    <div className="img-box-right">
                        <div className="logo">
                            <EFXQuiet />
                        </div>
                        <div className="text">{t('J_text')}</div>
                        <div className="img-box">
                            <EcoImg pc={'https://websiteoss.ecoflow.com/upload/image/1740991582916/%E8%A1%A8%E6%A0%BC.png'} />
                        </div>
                    </div>
                </div>
            )}
            {isH5 && (
                <div className="img-box-left">
                    <EcoImg pc={'https://websiteoss.ecoflow.com/upload/image/1740994069850/%E5%9B%BE%E7%89%87%20(1).jpg'} />
                </div>
            )}
        </div>
    );
};

export default JJ;
